module.exports = __webpack_public_path__ + "img/about-bg.57d47552.png";